import { VITE_ENVIRONMENT } from '~/lib/constants/env';
import { Environments } from '~/lib/constants/environment.constants';

export const isDevEnvironment = VITE_ENVIRONMENT === Environments.DEVELOPMENT;

export const isQAEnvironment = VITE_ENVIRONMENT === Environments.QA;

export const isTestEnvironment = VITE_ENVIRONMENT === Environments.TEST;

export const isStgEnvironment = VITE_ENVIRONMENT === Environments.STG;

export const isProdEnvironment = VITE_ENVIRONMENT === Environments.PROD;
